import { render, staticRenderFns } from "./SHeaderSection.vue?vue&type=template&id=2adf2e2f"
import script from "./sHeaderSection.ts?vue&type=script&lang=ts&external"
export * from "./sHeaderSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adf2e2f')) {
      api.createRecord('2adf2e2f', component.options)
    } else {
      api.reload('2adf2e2f', component.options)
    }
    module.hot.accept("./SHeaderSection.vue?vue&type=template&id=2adf2e2f", function () {
      api.rerender('2adf2e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-header-section/SHeaderSection.vue"
export default component.exports